import React, { Component } from "react";
import { Card, Button, Form, Alert, Badge } from "react-bootstrap";
import { Redirect } from 'react-router-dom'
import JobAddModal from './JobAddModal'
import JobEditModal from './JobEditModal'
import JobDeleteModal from './JobDeleteModal'
import axios from 'axios'
import moment from 'moment'
import DatePicker from 'react-datepicker'
import MaterialTable from 'material-table'
import { ThemeProvider } from '@material-ui/core'
import { createTheme } from '@material-ui/core/styles'
import AlertModal from './AlertModal'
import CommonLoader from "./loaderComponent/CommonLoader";
import CommonToast from "./Toaster/CommonToast";
import { validateExpenseForm } from "../utils/validation";

export default class Expense extends Component {

  constructor(props) {
    super(props)

    this.state = {
      departments: [],
      selectedDepartment: '',
      itemName: "",
      purchasedFrom: "",
      purchaseDate: "",
      amountSpent: '',
      hasError: false,
      errMsg: "",
      errors: {},
      showToast: false,
      toastMessage: '',
      toastVariant: '',
      color: '',
      loading: true
    }
  }

  componentDidMount() {
    this.setState({ loading: true });
    axios({
      method: 'get',
      url: '/departments',
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    })
      .then(res => {
        this.setState({ departments: res.data })
        setTimeout(() => {
          this.setState({ loading: false });
        }, 900);
      })
      .catch(err => {
        console.log(err)
        setTimeout(() => {
          this.setState({ loading: false });
        }, 900);
      })
  }

  pushDepartments = () => {
    let items = []
    this.state.departments.map((dept, index) => {
      items.push(<option key={index} value={dept.id}>{dept.departmentName}</option>)
    })
    return items
  }

  handleDateChange = (date, field) => {
    let errors = { ...this.state.errors };
    const currentDate = new Date();
    const firstDayOfCurrentMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
    if (field === "purchaseDate") {
      if (date < firstDayOfCurrentMonth) {
        errors.purchaseDate = "Purchase date cannot be in the past month.";
      } else {
        delete errors.purchaseDate;
      }

      this.setState({
        purchaseDate: date,
        errors,
      });
    }
  };

  handleChange = (event) => {
    const { value, name } = event.target;
    let errors = { ...this.state.errors };

    // Validate only for non-empty values
    if (name === "itemName" && value.trim() !== "") {
      delete errors.itemName;
    }
    if (name === "purchasedFrom" && value.trim() !== "") {
      delete errors.purchasedFrom;
    }
    if (name === "selectedDepartment") {
      errors.selectedDepartment = value ? "" : "Select a department";
    }

    // Validate amountSpent (only digits, 1-6)
    if (name === "amountSpent") {
      if (value.trim() === "") {
        errors.amountSpent = "Amount Spent is required";
      } else if (!/^\d{1,8}$/.test(value)) {
        errors.amountSpent = "Enter a valid amount (1-8 digits)";
      } else {
        errors.amountSpent = ""; // Remove error when valid
      }
    }


    this.setState({
      [name]: value,
      errors,
    });
  };


  onSubmit = (event) => {

    event.preventDefault()
    const errors = validateExpenseForm(
      this.state.itemName,
      this.state.purchasedFrom,
      this.state.purchaseDate,
      this.state.selectedDepartment,
      this.state.amountSpent
    );
    if (Object.keys(errors).length > 0) {
      this.setState({ errors, loading: false });
      return;
    }

    let newExpense = {
      expenseItemName: this.state.itemName,
      expenseItemStore: this.state.purchasedFrom,
      date: new Date(this.state.purchaseDate).setHours(15),
      amount: this.state.amountSpent,
      departmentId: this.state.selectedDepartment
    }

    axios({
      method: 'post',
      url: 'expenses/',
      data: newExpense,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    })
      .then(res => {
        this.setState({
          completed: true,
          toastMessage: "Expense created successfully!",
          toastVariant: 'success',
          color: 'green',
          done: true,
          showToast: true,
        });

        setTimeout(() => {
          this.setState({ loading: false, showToast: false });
          this.props.history.push('/expense-report')
        }, 900);
      })
      .catch(err => {
        this.setState({
          toastMessage: "Expense not created! ",
          toastVariant: 'danger',
          color: 'red',
          showToast: true,
          loading: false
        });
        setTimeout(() => {
          this.setState({ loading: false });
        }, 900);
        window.scrollTo(0, 0);
      })
  }

  render() {

    return (
      <>
        <CommonToast
          show={this.state.showToast}
          onClose={() => this.setState({ showToast: false })}
          message={this.state.toastMessage}
          variant={this.state.toastVariant}
          color={this.state.color}
        />

        <CommonLoader isLoading={this.state.loading}>
          <div className="container-fluid pt-2">
            <div className="row">

              {/* {this.state.hasError ? (
                <Alert variant="danger" className="m-3" block>
                  {this.state.errMsg}
                </Alert>
              ) : this.state.completed ? (
                <Alert variant="success" className="m-3">
                  Expense has been inserted.
                </Alert>
              ) : null} */}

              <div className="col-sm-12">
                <Card className="main-card">
                  <Card.Header>Add Expense</Card.Header>
                  <Card.Body>
                    <Card.Text>
                      <Form onSubmit={this.onSubmit}>
                        <Form.Group>
                          <Form.Label className="  required">Item Name: </Form.Label>
                          <Form.Control
                            type="text"
                            value={this.state.itemName}
                            onChange={this.handleChange}
                            name="itemName"
                            placeholder="Enter item name"

                          />
                        </Form.Group>
                        <span className="login-error">
                          {this.state.errors.itemName && <small className="text-danger">{this.state.errors.itemName}</small>}
                        </span>
                        <Form.Group>
                          <Form.Label className="  required">Purchased From: </Form.Label>
                          <Form.Control
                            type="text"
                            value={this.state.purchasedFrom}
                            onChange={this.handleChange}
                            name="purchasedFrom"
                            placeholder="Enter purchased from"

                          />
                        </Form.Group>
                        <span className="login-error">
                          {this.state.errors.purchasedFrom && <small className="text-danger">{this.state.errors.purchasedFrom}</small>}
                        </span>
                        <Form.Group>
                          <Form.Label className="  required">Purchase Date: </Form.Label>
                          <DatePicker
                            selected={this.state.purchaseDate}
                            className="form-control"
                            onChange={(date) => this.handleDateChange(date, "purchaseDate")}
                            placeholderText="Select purchase date"
                            minDate={new Date(new Date().getFullYear(), new Date().getMonth(), 1)} // Allows only current month & future
                          />
                          <span className="login-error">
                            {this.state.errors.purchaseDate && (
                              <small className="text-danger">{this.state.errors.purchaseDate}</small>
                            )}
                          </span>

                          {/* <Form.Row>
                            <DatePicker
                              className="form-control ml-1"
                              placeholderText="Pick purchased date"
                              selected={this.state.purchaseDate}
                              onChange={newDate => this.setState({ purchaseDate: newDate })}

                            />
                          </Form.Row> */}
                        </Form.Group>
                        <Form.Group>
                          <Form.Label className="  required">Amount Spent: </Form.Label>
                          <Form.Control
                            type="text"
                            value={this.state.amountSpent}
                            onChange={this.handleChange}
                            name="amountSpent"
                            placeholder="Enter amount"

                          />
                        </Form.Group>
                        <span className="login-error">
                          {this.state.errors.amountSpent && <small className="text-danger">{this.state.errors.amountSpent}</small>}
                        </span>
                        <Form.Group>
                          <Form.Label className="  required">Select Department: </Form.Label>
                          <Form.Control
                            as="select"
                            className="form-select"
                            value={this.state.selectedDepartment}
                            onChange={this.handleChange}
                            name="selectedDepartment"
                          >
                            <option value="">Choose one...</option>
                            {this.pushDepartments()}
                          </Form.Control>
                        </Form.Group>
                        <span className="login-error">
                          {this.state.errors.selectedDepartment && <small className="text-danger">{this.state.errors.selectedDepartment}</small>}
                        </span>
                        <Button type="submit" className="mt-2">Save</Button>
                      </Form>
                    </Card.Text>
                  </Card.Body>
                </Card>
              </div>
            </div>
          </div>
        </CommonLoader>
      </>
    );
  }
}